<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <div v-if="errormessage">
        <v-alert
          dismissible
          v-model="errormessage"
          dense
          outlined
          type="error"
          >{{ errormessage }}</v-alert
        >
      </div>

      <v-toolbar>
        <v-toolbar-title>{{ name }} </v-toolbar-title>
        <v-spacer></v-spacer>

        Add new
        <v-btn
          @click="newProduct('Add new')"
          class="ma-2"
          outlined
          small
          fab
          color="indigo"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in tabitems" :key="item.index">
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabitems" :key="item.index">
          <v-card flat>
            <v-data-table
              v-if="item.index === 0"
              :headers="headers"
              :items="data"
              item-key="Prod_Code"
              :search="search"
              :custom-filter="filterOnlyCapsText"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item }">
                <tr :key="item.Prod_Code">
                  <td>{{ item.Prod_Code }}</td>
                  <td>{{ item.Prod_Name }}</td>
                  <td>{{ item.CategoryName }}</td>
                  <td>{{ item.PartNo }}</td>
                  <td>{{ item.ModelCode }}</td>
                  <td class="number">
                    {{ item.Selling_Price | numberFormat }}
                  </td>
                  <td class="number">
                    {{ item.PackSize }}
                  </td>
                  <td class="number">
                    {{ item.qty }}
                  </td>
                  <td>
                    <v-btn
                      color="primary"
                      @click.stop="getData(item.Prod_Code, 'Edit Product')"
                    >
                      View
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-dialog v-model="dialog" max-width="900px">
        <v-card>
          <v-card-title>{{ dialogtitle }}</v-card-title>
          <v-card-text>
            <div v-if="dialogerror">
              <v-alert
                dismissible
                v-model="dialogerror"
                dense
                outlined
                type="error"
                >{{ dialogerror }}</v-alert
              >
            </div>
            <p v-if="product.Prod_Code" class="mx-4">
              Product Code : {{ product.Prod_Code }}
            </p>
            <v-text-field
              v-model.trim="product.Prod_Name"
              label="Product Name"
              class="mx-4"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model.trim="product.CategoryName"
              label="Category"
              class="mx-4"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model.trim="product.Selling_Price"
              label="Selling"
              class="mx-4"
              type="number"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model.number="product.PackSize"
              label="Pack Size"
              class="mx-4"
              :rules="[rules.required]"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text @click="dialog = false">
              Close
            </v-btn>
            <v-btn color="green darken-1" text @click="save"> Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
var numeral = require("numeral");
import { HTTP, setAuthToken,BASE_URL } from "../../../lib/http.common";
import { Decrypt } from "../../../lib/encryption";
//import sql from 'mssql'
export default {
  name: "Products",
  computed: {},
  components: {},
  filters: {
    toDate(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY hh:mm");
      }
    },
    numberFormat(v) {
      //if (v) {
      return numeral(v).format("0,0.00");
      // }
    },
  },
  methods: {
    save() {
      let user = JSON.parse(Decrypt(localStorage.user));
      let product = {
        id: this.product.Prod_Code ? this.product.Prod_Code : 0,
        name: this.product.Prod_Name,
        category: this.product.CategoryName,
        selling: this.product.Selling_Price,
        packsize: this.product.PackSize,
        user: user.User,
      };

      product.user = JSON.parse(Decrypt(localStorage.user)).User;

      HTTP.post(BASE_URL+`product/${product.id}`, product)
        .then((response) => {
          if (response.data[0].success) {
            this.dialogerror = null;
            this.dialog = false;
            this.getProducts();            
          }
          else{
            if (!response.data[0].season) this.$router.push("/login");
          }
        })
        .catch((e) => {
          this.dialogerror = e;
        });
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase()) !== -1
      );
    },
    newProduct(type) {
      this.dialogtitle = type;
      this.product = {};
      this.dialog = true;
    },
    getData(doc, type) {
      HTTP.get(BASE_URL+`product/one/` + doc)
        .then((response) => {
          (this.dialogtitle = type),
            (this.product = response.data[0].dataset[0]);
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          } else {
            this.dialog = true;
            this.errormessage = null;
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },
    getProducts() {
      HTTP.get(BASE_URL+`product/` + this.filter)
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          } else {
            this.errormessage = null;
            this.data = response.data[0].dataset;
          }

          this.overlay = false;
        })
        .catch((e) => {
          this.errormessage = e;
          this.overlay = false;
        });
    },
  },

  beforeCreate() {
    setAuthToken();
  },
  mounted() {
    this.getProducts();
  },
  beforeDestroy() {},

  data() {
    return {
      search: "",
      overlay: true,
      name: "PRODUCTS",
      tab: null,
      tabitems: [{ name: "PRODUCTS", index: 0 }],
      Customer: "",
      dialog: false,
      current: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      
      posts: [],
      error: false,
      errormessage: null,
     dialogtitle: "Edit Product", dialogerror: null,
      data: [],
      product: {},

      rules: {
        required: function (value) {
          return !!value || "Required.";
        },
      },

      headers: [
        {
          value: "Prod_Code",
          text: "Code",
          sortable: true,
        },
        {
          value: "Prod_Name",
          text: "Product Name",
          sortable: true,
        },
        {
          value: "CategoryName",
          text: "Category",
          sortable: true,
        },
        {
          value: "PartNo",
          text: "Part No",
          sortable: true,
        },
        {
          value: "ModelCode",
          text: "Model Code",
          sortable: true,
        },

        {
          value: "Selling_Price",
          text: "Selling",
          align: "right",
          sortable: true,
        },
        {
          value: "PackSize",
          text: "Pack Size",
          align: "right",
          sortable: true,
        },
        
        {
          value: "qty",
          text: "Stock",
          align: "right",
          sortable: true,
        },
        { value: "actions", text: "Actions" },
      ],
      timer: undefined,
    };
  },
};
</script>


<style scoped>
.modal {
  justify-content: center;
  align-items: center;
  width: 900px;
}
.modal-open .modal {
  z-index: 1050;
}
.card-body {
  color: #fff;
  background: #3e3e3e;
}
.refresh {
  margin: 15px;
}

.number {
  text-align: end;
}
</style>


